import {AutomationStatus, ExecutionStatus} from "crqlar-react-common/dist/models/automation/automation";
import {FolioStatus} from "crqlar-react-common/dist/models/billing/folio.model";
import {ReservationStatus} from "crqlar-react-common/dist/models/reservation/reservation.model";
import {SurveyStatus, SurveyType} from "crqlar-react-common/dist/models/survey/survey.model";
import {SurveyReviewState} from "crqlar-react-common/dist/models/survey/surveySubmission.model";
import type {DigitalSigningStatus} from "../../digitalSigning/public/digitalSigning.types";
import {
    RESOURCE_ELEMENT_DEFAULT_COLORS as COMMON_RESOURCE_ELEMENT_DEFAULT_COLORS,
} from "crqlar-react-common/dist/components/uiElements/ResourceElement";

export const RESOURCE_ELEMENT_DEFAULT_COLORS = COMMON_RESOURCE_ELEMENT_DEFAULT_COLORS;

const RESERVATION_STATUS_COLORS: Partial<Record<ReservationStatus, string>> = {
    [ReservationStatus.CONFIRMED]: "success.main",
    [ReservationStatus.ACTIVE]: "success.main",
    [ReservationStatus.PENDING]: "warning.main",
    [ReservationStatus.OPTION]: "warning.main",
    [ReservationStatus.CANCELLED]: "error.main",
    [ReservationStatus.NO_SHOW]: "error.main",
    [ReservationStatus.COMPLETED]: "text.secondary",
};

export const getReservationStatusColor = (status: ReservationStatus | undefined) => (
    status ? RESERVATION_STATUS_COLORS[status] ?? "text.secondary" : "text.secondary"
);

const SURVEY_TYPE_COLORS: Partial<Record<SurveyType, string>> = {
    [SurveyType.PRE_STAY]: "info.main",
    [SurveyType.POST_STAY]: "success.main",
    [SurveyType.PRE_SERVICE]: "warning.main",
    [SurveyType.POST_SERVICE]: "secondary.main",
    [SurveyType.ANONYMOUS]: "text.secondary",
};

export const getSurveyTypeColor = (type: SurveyType | undefined) => (
    type ? SURVEY_TYPE_COLORS[type] ?? "text.secondary" : "text.secondary"
);

const SURVEY_STATUS_COLORS: Partial<Record<SurveyStatus, string>> = {
    [SurveyStatus.PUBLISHED]: "success.main",
    [SurveyStatus.DRAFT]: "error.main",
};

export const getSurveyStatusColor = (status: SurveyStatus | undefined) => (
    status ? SURVEY_STATUS_COLORS[status] ?? "text.secondary" : "text.secondary"
);

const SURVEY_REVIEW_STATE_COLORS: Partial<Record<SurveyReviewState, string>> = {
    [SurveyReviewState.OPEN]: "warning.main",
    [SurveyReviewState.REVIEWED]: "success.main",
};

export const getSurveyReviewStateColor = (state: SurveyReviewState | undefined) => (
    state ? SURVEY_REVIEW_STATE_COLORS[state] ?? "text.secondary" : "text.secondary"
);

const AUTOMATION_STATUS_COLORS: Partial<Record<AutomationStatus, string>> = {
    [AutomationStatus.ACTIVE]: "success.main",
    [AutomationStatus.PAUSED]: "warning.main",
    [AutomationStatus.DRAFT]: "text.secondary",
    [AutomationStatus.ARCHIVED]: "error.main",
};

export const getAutomationStatusColor = (status: AutomationStatus | undefined) => (
    status ? AUTOMATION_STATUS_COLORS[status] ?? "text.secondary" : "text.secondary"
);

const EXECUTION_STATUS_COLORS: Partial<Record<ExecutionStatus, string>> = {
    [ExecutionStatus.PENDING]: "warning.main",
    [ExecutionStatus.WAITING]: "warning.main",
    [ExecutionStatus.RUNNING]: "info.main",
    [ExecutionStatus.COMPLETED]: "success.main",
    [ExecutionStatus.FAILED]: "error.main",
    [ExecutionStatus.CANCELLED]: "text.secondary",
};

export const getExecutionStatusColor = (status: ExecutionStatus | undefined) => (
    status ? EXECUTION_STATUS_COLORS[status] ?? "text.secondary" : "text.secondary"
);

// The signing's own dots, the same in the lists and the dialog's header
const DIGITAL_SIGNING_STATUS_COLORS: Record<DigitalSigningStatus, string> = {
    PENDING: "#E0A100",
    OPENED: "#1E88E5",
    SIGNED: "#7E57C2",
    CONFIRMED: "#2E7D32",
    VOIDED: "#9E9E9E",
    EXPIRED: "#BDBDBD",
};

export const getDigitalSigningStatusColor = (status: DigitalSigningStatus | undefined) => (
    status ? DIGITAL_SIGNING_STATUS_COLORS[status] ?? "text.secondary" : "text.secondary"
);

// A finalized folio ("Finalized", OPEN) still waits for its payment
const FOLIO_STATUS_COLORS: Record<FolioStatus, string> = {
    [FolioStatus.DRAFT]: "text.secondary",
    [FolioStatus.OPEN]: "warning.main",
    [FolioStatus.PAID]: "success.main",
    [FolioStatus.PREAUTHORIZED]: "info.main",
    [FolioStatus.RELEASED]: "text.secondary",
    [FolioStatus.REFUNDED]: "text.secondary",
    [FolioStatus.VOID]: "error.main",
    [FolioStatus.UNCOLLECTABLE]: "error.main",
};

export const getFolioStatusColor = (status: FolioStatus | undefined) => (
    status ? FOLIO_STATUS_COLORS[status] ?? "text.secondary" : "text.secondary"
);
